import { render, staticRenderFns } from "./MmfFilter.vue?vue&type=template&id=d87c927e&"
import script from "./MmfFilter.vue?vue&type=script&lang=js&"
export * from "./MmfFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports